import React, { useState } from 'react'
import propTypes from 'prop-types'
import './avatar.scss'
import { FaUserAlt } from 'react-icons/fa'
import { ICUserAvatar } from '../../assets'
import LazyImage from '../LazyImage'
import { Spinner } from 'react-bootstrap'

function Avatar(props) {
  const className = [props.className]
  className.push('default')
  if (props.square) className.push('square')
  if (props.rounded)
    className.push(
      props.rounded === true
        ? 'rounded-avatar'
        : `rounded-avatar-${props.rounded}`,
    )
  if (props.border) className.push('border-avatar')
  if (props.hasShadow) className.push('shadow')
  const size = {
    height: props.size || '60px',
    width: props.size || '60px',
  }
  const style = {
    ...size,
    ...props.style,
  }
  const sizeDefaultAvatar = props.size ? props.size.split('px') : [60]
  const sizeNoAvatar = sizeDefaultAvatar[0] / 2
  const sizeFontText = sizeDefaultAvatar[0] / 3
  let getText
  if (props.text) {
    getText = `${props.text[0]}${props.text[props.text.length - 1]}`
  }
  const [brokeImage, setBrokeImage] = useState(false)
  const addDefaultSrc = (ev) => {
    setBrokeImage(true)
    ev.target.src = ICUserAvatar
  }

  if (props.src) {
    return (
      <div className='img-avatar d-inline-block'>
        {brokeImage ? (
          <span className={className.join(' ') + ' bg-secondary'} style={style}>
            {props.isLoading ? (
              <Spinner animation='border' />
            ) : (
              <FaUserAlt size={`${sizeNoAvatar}px`} color='white' />
            )}
          </span>
        ) : props.isLoading ? (
          <span className={className.join(' ') + ' bg-secondary'} style={style}>
            <Spinner animation='border' />
          </span>
        ) : (
          <LazyImage
            src={props.src}
            onError={addDefaultSrc}
            className={className.join(' ')}
            height={size.height}
            width={size.width}
            alt={props.alt || 'avatar'}
          />
        )}
      </div>
    )
  } else if (props.isLoading) {
    return (
      <div className='img-avatar d-inline-block'>
        <span className={className.join(' ') + ' bg-secondary'} style={style}>
          <Spinner animation='border' />
        </span>
      </div>
    )
  } else {
    if (props.text) {
      return (
        <div className='img-avatar d-inline-block'>
          <span className={className.join(' ') + ' bg-secondary'} style={style}>
            <span style={{ fontSize: `${sizeFontText}px` }}>{getText}</span>
          </span>
        </div>
      )
    } else {
      return (
        <div className='img-avatar d-inline-block'>
          <span className={className.join(' ') + ' bg-secondary'} style={style}>
            <FaUserAlt size={`${sizeNoAvatar}px`} color='white' />
          </span>
        </div>
      )
    }
  }
}

export default Avatar

Avatar.prototype = {
  size: propTypes.string,
  className: propTypes.string,
  alt: propTypes.string,
  rounded: propTypes.oneOf([
    'sm',
    'md',
    'lg',
    'top',
    'bottom',
    'left',
    'right',
  ]),
  square: propTypes.string,
  border: propTypes.string,
  style: propTypes.object,
  text: propTypes.string,
  hasShadow: propTypes.string,
}
